/// <amd-module name="Test/ManualTestReports/TestReportsCommon/ITestProgressReportWidgetProps" />

import { IVssComponentProperties} from "VSS/Platform/Layout";

export interface ITestProgressReportWidgetProps extends IVssComponentProperties {
    widgetName: string;
    onRenderingStart: (widgetName: string, additionalProps?: {[key: string]: any}) => void;
    onRenderingEnd: (widgetName: string, additionalProps?: {[key: string]: any}) => void;
}
